module.exports = __webpack_public_path__ + "img/fendanyun_07.f831bab0.jpg";